<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t("invoice") }}</div>
        <div class="section-subTitle my-2">
          {{ $tc("listofall") }} {{ $t("invoice") }} {{ $tc("incinematic") }}
        </div>
      </div>
      <div>
        <router-link variant="default" class="btn-blue" to="/fnb/add-invoice">{{
          $tc("add")
        }}</router-link>
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div>
        <b-form-input
          v-model="searchValue"
          v-debounce:300="searchInvoice"
          placeholder="Search..."
        ></b-form-input>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center justify-content-between w-100">
        <FilterByStatusDropdown
          :onSelect="filterIsActive => getPurchaseOrderList(filterIsActive)"
        />
        <div class="mx-2">
          <b-dropdown id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
        <!-- <div class="viewing-status">
          {{ $t('viewing') }}
          <span>1-20</span>
          {{ $t('of') }}
          <span>36</span>
          <button class="btn-prev mx-2"></button>
          <button class="btn-next"></button>
        </div>-->
        <button
          class="btnj btn-gridView mr-3"
          v-if="GridViewFlag"
          :class="gridView ? 'active' : ''"
          v-on:click="viewType('gridView')"
        ></button>
        <button
          class="btnj btn-listView"
          v-if="GridViewFlag"
          :class="listView ? 'active' : ''"
          v-on:click="viewType('listView')"
        ></button>
      </div>
    </div>

    <!-- LIST VIEW -->
    <table class="list-view-table text-center" v-if="listView">
      <thead>
        <tr>
          <th>
            <img
              @click="
                onSortValue('orderno', (orderAscending = !orderAscending))
              "
              src="@/assets/img/icons/sort.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $t("orderNo") }}
          </th>
          <th>
            <img
              @click="onSortValue('date', (dateAscending = !dateAscending))"
              src="@/assets/img/icons/sort.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $t("date") }}
          </th>
          <th>{{ $tc("cinema", 1) }}</th>
          <th>{{ $tc("vendor", 1) }}</th>
          <th>{{ $t("total") }} {{ $t("amount") }}</th>
          <th class="text-right">
            <span class="pr-3">{{ $tc("status", 1) }}</span>
          </th>
        </tr>
      </thead>

      <tbody v-if="invoiceList.length>0">
        <tr
          v-for="(invoice, purchaseOrderList) in invoiceList"
          :key="purchaseOrderList"
        >
          <td style="text-align:right">{{ invoice.i_number }}</td>
          <td>{{ invoice.i_date | dateparse }}</td>
          <td>{{ invoice.cine_name }}</td>
          <td>{{ invoice.v_name }}</td>
          <td style="text-align:right">{{ invoice.i_total_amount }}</td>
          <td>
            <div class="d-flex justify-content-end align-items-center">
              <!-- <label class="ios-switch">
                <input
                  type="checkbox"
                  class="ios-checkbox"
                  :checked="invoice.i_is_active == 'Y' ? true : false"
                  disabled
                />
                <span class="switch-slider"></span>
              </label> -->
              <StatusDot
                :status="
                  invoice.i_is_active === 'Y'
                    ? 'active'
                    : invoice.i_is_active === 'N' && 'inactive'
                "
              />

              <div>
                <b-dropdown right variant="edit" class="ml-4">
                  <b-dropdown-item
                    v-if="invoice.i_lock !== 'Y'"
                    @click="goToRoute('/fnb/edit-invoice', invoice)"
                  >
                    <span class="edit-pen"></span>
                    {{ $t("edit") }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="goToRoute('/fnb/view-invoice', invoice)"
                  >
                    <span class="icon-eye mr-1"></span>
                    {{ $t("view") }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td colspan="6">
            <NoRecords/>
          </td>
        </tr>
      </tbody>
    </table>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>

    <!-- GRID VIEW -->
    <div class="desg-grid-container" v-if="gridView">
      <div
        class="col-md-4 col-lg-4 col-xl-3 px-0"
        v-for="(invoice, purchaseOrderkey) in invoiceList"
        :key="purchaseOrderkey"
      >
        <div class="desg-box">
          <div class="d-flex justify-content-between">
            <h6>{{ invoice.i_number }}</h6>
            <div>
              <b-dropdown right variant="edit">
                <b-dropdown-item
                  v-if="invoice.i_lock !== 'Y'"
                  @click="goToRoute('/fnb/edit-invoice', invoice)"
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="goToRoute('/fnb/view-invoice', invoice)"
                >
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-end">
            <div class="d-flex align-items-end lh-1"></div>
            <div class="d-flex align-items-end">
              <!-- <label class="ios-switch">
                <input type="checkbox" class="ios-checkbox" />
                <span class="switch-slider"></span>
              </label> -->
              <StatusDot />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import PosFnbService from "@/services/PosFnbService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      cinema_id: null,
      gridView: false,
      listView: true,
      invoiceList: [],
      orderAscending: true,
      dateAscending: true,
      searchValue: ""
    };
  },

  mounted() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    this.cinema_id = obj;
    this.getPurchaseOrderList();
  },
  beforeMount() {
    this.getviewingnumber();
  },
  methods: {
    searchInvoice() {
      this.getPurchaseOrderList();
    },
    onSortValue: function(column, ascending) {
      // console.log('ascending :>> ', ascending);
      if (column == "orderno") {
        if (ascending == false) {
          this.invoiceList = this.invoiceList.sort(function(a, b) {
            return b.i_number - a.i_number;
          });
        } else {
          this.invoiceList = this.invoiceList.sort(function(a, b) {
            return a.i_number - b.i_number;
          });
        }
        // this.orderAscending = "desc";
      } else if (column == "date") {
        if (ascending == false) {
          this.invoiceList = this.invoiceList.sort(function(a, b) {
            return new Date(a.i_date) - new Date(b.i_date);
          });
        } else {
          this.invoiceList = this.invoiceList.sort(function(a, b) {
            return new Date(b.i_date) - new Date(a.i_date);
          });
        }
        // this.dateAscending = "desc";
      }
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 }
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    /* eslint-disable */
    onChangePagination: function(event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getPurchaseOrderList();
      } else {
        this.currentPage = event;
        this.getPurchaseOrderList();
      }
    },
    viewType: function(viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
    goToRoute: function(path, { i_number, i_id }) {
      console.log("i_number,i_id :", i_number, i_id);
      this.$router.push({
        path: path,
        query: {
          i_number: i_number,
          i_id: i_id
        }
      });
    },
    getPurchaseOrderList(filterIsActive = "Y") {
      this.invoiceList = [];
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        searchValue: this.searchValue,
        cinema_id: this.cinema_id,
        filterIsActive
      };
      PosFnbService.GetAllInvoices(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.invoiceList = data.Records;
            console.log("invoiceList :>> ", this.invoiceList);
            if (data.totalRows >= 10) {
              this.rows = data.totalRows;
              this.selectedvalue =
                this.selectedvalue < 10 ? 10 : this.selectedvalue;
            } else {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
          } else {
            this.invoiceList = [];
            this.rows = data.totalRows;
            this.selectedvalue = data.totalRows;
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/InvoiceComponents/listInvoice.vue